import { RoomExportExcelState, RoomExportExcelActionTypes, ROOM_EXPORT_EXCEL_REQUEST, ROOM_EXPORT_EXCEL_SUCCESS, ROOM_EXPORT_EXCEL_FAILURE } from "store/reducers/room/exportExcel/types";

const defaultState: RoomExportExcelState = {
  isLoading: false,
  errorMessage: ""
};

export default function exportExcel(state = defaultState, action: RoomExportExcelActionTypes): RoomExportExcelState {
  switch (action.type) {
    case ROOM_EXPORT_EXCEL_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case ROOM_EXPORT_EXCEL_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case ROOM_EXPORT_EXCEL_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};